var dataGridBlockName = 'data-grid';
var headerBlockName = "".concat(dataGridBlockName, "-header");
var bodyBlockName = "".concat(dataGridBlockName, "-body");

export { bodyBlockName, dataGridBlockName, headerBlockName };
//# sourceMappingURL=blockNames.js.map
